import { createApp } from "vue";
import App from "./App.vue";
import { CDN_URL, CDN_UPLOAD_URL } from "@/utils/cdn";
const app = createApp(App);
// 引入全局css
import "@/assets/css/common.css";
// 引入element-plus
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
// 注册所有图标
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
// 设置中文
import zhCn from "element-plus/es/locale/lang/zh-cn";

// 引入全局自定义指令
import * as directives from "./utils/dirctives";

Object.keys(directives).forEach((key) => {
  app.directive(key, directives[key]);
});

// 引入pinia
import { createPinia } from "pinia";
const pinia = createPinia();

// 添加全局属性
app.config.globalProperties.$cdnUrl = CDN_URL;
app.config.globalProperties.$uploadUrl = CDN_UPLOAD_URL;
app.config.globalProperties.$url = "https://mercdn.str.moe/";
app.config.globalProperties.orderStatusList = [
  {
    text: "全部",
    code: 0,
  },
  {
    text: "待支付",
    code: 1,
  },
  {
    text: "已支付待购买",
    code: 2,
  },
  {
    text: "平台已购买",
    code: 3,
  },
  {
    text: "卖家已发货",
    code: 4,
  },
  {
    text: "已入库",
    code: 5,
  },
  {
    text: "合包中",
    code: 6,
  },
  {
    text: "待支付运费",
    code: 7,
  },
  {
    text: "待发货",
    code: 8,
  },
  {
    text: "运输中",
    code: 9,
  },
  {
    text: "已到达",
    code: 10,
  },
  {
    text: "已完成",
    code: 11,
  },
  {
    text: "购买失败",
    code: 12,
  },
  {
    text: "已取消",
    code: 13,
  },
  {
    text: "退款中",
    code: 14,
  },
  {
    text: "已退款",
    code: 15,
  },
];

import print from 'vue3-print-nb'

// 引入路由
import router from "@/router/router";
import { installStorageTaskGuards } from "@/composables/buyOrder/useStorageTasks";
installStorageTaskGuards(router);
// 引入路由首位
// import '@/router'
app
  .use(router)
  .use(print)
  .use(pinia)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .mount("#app");
